"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseAddress = void 0;
/**
 * Reusable parseAddress function for address fields
 *
 * @param data - address text to parse
 * @returns address - Address object
 */
const parseAddress = (data) => {
    const address = {
        streetLine1: '',
        streetLine2: '',
        city: '',
        state: '',
        country: '',
        zipCode: '',
    };
    let addressArr = data.split(',');
    addressArr = addressArr.map((value) => value.trim());
    if (addressArr.length === 6) {
        [
            address.streetLine1,
            address.streetLine2,
            address.city,
            address.state,
            address.country,
            address.zipCode,
        ] = addressArr;
    }
    else if (addressArr.length === 5) {
        [
            address.streetLine1,
            address.city,
            address.state,
            address.country,
            address.zipCode,
        ] = addressArr;
    }
    return address;
};
exports.parseAddress = parseAddress;
